export default __webpack_public_path__ + "static/media/halimat.d502bf73.png";